export const tournamentCache = {};
export const tournamentSubscribers = new Set();
